import Home from "./Home";
import Payment from "./Payment";
import detectEthereumProvider from '@metamask/detect-provider';

try{
  detectEthereumProvider();
} catch(err) {
  alert("MM not installed")
}

function App() {

if(window.ethereum) {
  //console.log("window.ethereum OK");
  return (
      <Payment />
  )
} else {
  //console.log("No window.ethereum detected!");
  return (
      <Home />
  )
}}

export default App;